import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_app/_dashboard/groups/$groupName/students/quiz-submissions/quizzes',
)({
  component: () => <Outlet />,
});
